import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { UpdateUserPreferencesRequest } from '@routes/sidebar/settings/api/settings.api.ts';
import {
    requestUserDataDeletion,
    updateUserPreferences as updatePreferences,
} from '@routes/sidebar/settings/api/settings.api.ts';
import { extractError } from '@utils/slice.ts';

interface SettingsSlice {
    error: Record<string, any> | null;
    isRequestUserDeletionPending: boolean;
    isUpdateUserPreferencesPending: boolean;
}

const initialState: SettingsSlice = {
    error: null,
    isRequestUserDeletionPending: false,
    isUpdateUserPreferencesPending: false,
};

export const requestUserDeletion = createAsyncThunk<any, void, { rejectValue: any }>(
    'settings/requestUserDeletion',
    (_, { rejectWithValue }) =>
        requestUserDataDeletion()
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return rejectWithValue(err);
            }),
);

export const updateUserPreferences = createAsyncThunk<any, UpdateUserPreferencesRequest, { rejectValue: any }>(
    'settings/updateUserPreferences',
    (updateUserPreferencesPayload, { rejectWithValue }) =>
        updatePreferences(updateUserPreferencesPayload)
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return rejectWithValue(err);
            }),
);

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(requestUserDeletion.pending, (state) => {
            state.error = null;
            state.isRequestUserDeletionPending = true;
        });
        builder.addCase(requestUserDeletion.fulfilled, (state) => {
            state.isRequestUserDeletionPending = false;
        });
        builder.addCase(requestUserDeletion.rejected, (state, action) => {
            state.error = extractError(action);
            state.isRequestUserDeletionPending = false;
        });
        builder.addCase(updateUserPreferences.pending, (state) => {
            state.error = null;
            state.isUpdateUserPreferencesPending = true;
        });
        builder.addCase(updateUserPreferences.fulfilled, (state) => {
            state.isUpdateUserPreferencesPending = false;
        });
        builder.addCase(updateUserPreferences.rejected, (state, action) => {
            state.error = extractError(action);
            state.isUpdateUserPreferencesPending = false;
        });
    },
});

export default settingsSlice.reducer;
